<template>
  <div
    v-on-clickaway="close"
  >
    <div
      class="select-autocomplete"
      :class="{ 'select-autocomplete_error': error }"
    >
      <label
        v-if="label"
        class="select__label"
      >
        {{ label }}
        <span v-if="required" class="select__label-required">*</span>
      </label>
      <div class="select-autocomplete__field">
        <input
          v-bind="$attrs"
          :value="value"
          :placeholder="placeholder"
          type="text"
          class="select-autocomplete__field-input"
          @input="onInput($event.target.value)"
          @click="isShow = !isShow"
          @focus="error = false"
        >
      </div>
      <ul
        v-show="isShow"
        class="select-autocomplete__results"
      >
        <li
          v-for="(result, i) in filteredItems"
          :key="i"
          class="select-autocomplete__result"
          @click="setResult(result)"
        >
          {{ result.text }}
        </li>
      </ul>
      <Transition name="slide-from-top">
        <span
          v-if="error && errorMsg"
          class="input__error-msg"
        >
          {{ errorMsg }}
        </span>
        <!-- <ErrorIcon /> -->
      </Transition>
    </div>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'
  // import ErrorIcon from '@/assets/img/icons/error.svg?inline'

  export default {
    name: 'BaseAutoComplete',
    // components: { ErrorIcon },
    mixins: [ clickaway ],
    props: {
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        default: () => []
      },
      placeholder: {
        type: String,
        default: ''
      },
      errorMsg: {
        type: String,
        default: ''
      },
      scrollbar: {
        type: String,
        default: 'custom'
      }
    },
    data () {
      return {
        error: null,
        isShow: false,
        value: '',
        results: []
      }
    },

    computed: {
      filteredItems () {
        if (this.value.length === 0) {
          return this.items
        }
        return this.items.filter(item => item.text.toLowerCase().indexOf(this.value.toLowerCase()) > -1)
      }
    },

    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },
    created () {
      this.value = ''
    },
    methods: {
      onInput (value) {
        this.$emit('input', value)
        const app = this
        app.value = value
      },

      setResult (result) {
        this.value = result.value
        this.$emit('input', this.value)
        this.isShow = false
      },
      close () {
        this.isShow = false
      }
    }
  }
</script>

<style lang="scss">
  .select-autocomplete {
    position: relative;
    min-width: 290px;
    padding-bottom: 28px;
    margin-bottom: 10px;

    &__field {
      border-radius: 0;
      position: relative;

      &::after {
        position: absolute;
        top: 50%;
        right: 5%;
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        padding-top: 0.25em;
        color: #fff;
        text-align: center;
        content: "!";
        background-color: $c-active;
        border-radius: 50%;
        opacity: 0;
        transition: opacity 0.3s;
        transform: translateY(-50%);
      }

      &-input {
        display: block;
        width: 100%;
        padding: 0.75em 1.3em;
        font-size: 16px;
        line-height: 1;
        background-color: $c-gray-extra-light-2;
        border: none;
        outline: none;
        caret-color: $c-active-light;
        appearance: none;
        transition: 0.3s;
        border-radius: 0;

        @include hover {
          background-color: $c-gray;
        }
      }
    }

    &__results {
      position: absolute;
      top: calc(100% - 28px);
      left: 0;
      z-index: 999;
      width: 100%;
      max-height: 235px;
      overflow: auto;
      list-style: none;
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
      box-shadow: 2px 2px 5px rgba($c-black, 0.1);
      transition: 0.3s;
      -webkit-overflow-scrolling: touch;

      @include custom-scrollbar();
    }

    &__result {
      padding: 0.938em 1.3em;
      font-size: 16px;
      line-height: 1;
      cursor: pointer;
      background-color: $c-gray-extra-light-2;
      border-top: 1px solid $c-gray;
      transition: background-color 0.3s;

      @include hover {
        background-color: $c-gray;
      }
    }

    &_error {
      .select-autocomplete__field-input {
        padding-right: 3.5em;
        background-color: #fcded8;
      }

      .select-autocomplete__field::after {
        opacity: 1;
      }
    }
  }
</style>
